import { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { useMutation } from '@apollo/client';

import { useErrorToast } from '../components/Toast';
import basicUserProfileGQL from '../graphql/basicUserProfile.graphql';
import refreshBankAccountLoginMut from '../graphql/mutations/payments/refreshBankAccountLogin.graphql';
import globalBannerQuery from '../graphql/queries/globalBanner.graphql';

import usePlaidLinkToken from './usePlaidLinkToken';

const useLoginPlaidLink = ({ paymentMethodId, itemId }) => {
  const [refreshBankAccountLogin, { loading: refreshing }] = useMutation(
    refreshBankAccountLoginMut,
  );
  const showErrorMessage = useErrorToast();

  const { linkToken } = usePlaidLinkToken({
    paymentMethodId,
    itemId,
    manualMicrodepositsFlow: true,
    updateMode: true,
  });
  const { open, ready, error } = usePlaidLink({
    token: linkToken,
    onSuccess: async (_data) => {
      await refreshBankAccountLogin({
        variables: {
          paymentMethodId,
        },
        refetchQueries: [
          { query: basicUserProfileGQL },
          {
            query: globalBannerQuery,
          },
        ],
        awaitRefetchQueries: true,
      });
    },
  });

  useEffect(() => {
    if (error) {
      showErrorMessage('There was an error connecting to your bank');
    }
  }, [error]);

  const loading = refreshing || !ready;

  return { open, loading };
};

export default useLoginPlaidLink;
